import { PencilSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Edit = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <PencilSimpleIcon size={Sizes[size]} {...rest} color={fill} />;
};

Edit.displayName = 'Edit';
